//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import times from 'lodash/times';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import PlusDisplayLayer from '~/components/atoms/Editorial/PlusDisplayLayer.vue';
var RATIOS = {
  '4:3': 'ri-4_3',
  '1:1': ''
};
export default {
  name: 'InspirationImageDuoSquare',
  components: {
    PlusDisplayLayer
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var _ref, _ref11, _ref12;

      return {
        backgroundColor: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? _ref12.background_color : _ref12 : _ref12) || '',
        spacing: (_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.spacing : _ref11 : _ref11,
        images: times(this.payload.items.length, Number).map(i => {
          var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10;

          return {
            imgSrc: formatPrismicImage((_ref10 = this.payload) != null ? (_ref10 = _ref10.items) != null ? (_ref10 = _ref10[i]) != null ? (_ref10 = _ref10.image) != null ? _ref10.url : _ref10 : _ref10 : _ref10 : _ref10) || EMPTY_PIXEL,
            imgSrcset: "".concat(formatPrismicImage((_ref9 = this.payload) != null ? (_ref9 = _ref9.items) != null ? (_ref9 = _ref9[i]) != null ? (_ref9 = _ref9.image) != null ? _ref9.url : _ref9 : _ref9 : _ref9 : _ref9, ['w_180', 'dpr_2']), " 360w,\n            ").concat(formatPrismicImage((_ref8 = this.payload) != null ? (_ref8 = _ref8.items) != null ? (_ref8 = _ref8[i]) != null ? (_ref8 = _ref8.image) != null ? _ref8.url : _ref8 : _ref8 : _ref8 : _ref8, ['w_390', 'dpr_2']), " 780w"),
            alt: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.items) != null ? (_ref7 = _ref7[i]) != null ? _ref7.alt : _ref7 : _ref7 : _ref7) || '',
            reference: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.items) != null ? (_ref6 = _ref6[i]) != null ? _ref6.reference : _ref6 : _ref6 : _ref6) || '',
            layer: (_ref5 = this.payload) != null ? (_ref5 = _ref5.items) != null ? (_ref5 = _ref5[i]) != null ? _ref5.layer : _ref5 : _ref5 : _ref5,
            tracking: {
              data: {
                event_category: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.items) != null ? (_ref4 = _ref4[i]) != null ? _ref4.event_category1 : _ref4 : _ref4 : _ref4) || '',
                event_action: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.items) != null ? (_ref3 = _ref3[i]) != null ? _ref3.event_action1 : _ref3 : _ref3 : _ref3) || '',
                event_label: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.items) != null ? (_ref2 = _ref2[i]) != null ? _ref2.event_label1 : _ref2 : _ref2 : _ref2) || ''
              }
            }
          };
        }),
        imgRatio: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.image_ratio : _ref : _ref) || '1:1'
      };
    },

    elements() {
      return this.currentPayload.images.slice(0, 3);
    },

    builderRatio() {
      return RATIOS[this.currentPayload.imgRatio];
    },

    isSquared() {
      return this.currentPayload.imgRatio === '1:1';
    }

  },
  methods: {
    structureClass(key) {
      return {
        'square-first col-12 px-sm-only-0': key === 0,
        'square-second col-6': key === 1,
        'square-third col-6': key === 2
      };
    }

  }
};